var map = {
	"./ball-blue.svg": "2917",
	"./ball-red.svg": "1000",
	"./ball.svg": "4748",
	"./capsule-blue.svg": "41bf",
	"./capsule-red.svg": "cee7",
	"./capsule.svg": "0e27",
	"./convex.svg": "2741",
	"./convex2.svg": "52dd",
	"./egg-blue.svg": "fd2c",
	"./egg-red.svg": "88dc",
	"./egg.svg": "695e",
	"./not-convex.svg": "4ac3",
	"./not-convex2.svg": "29f4",
	"./oval-blue.svg": "6146",
	"./oval-red.svg": "c986",
	"./oval.svg": "c919",
	"./round-blue.svg": "3003",
	"./round-red.svg": "b6d9",
	"./round.svg": "101f",
	"./special-blue.svg": "9e9b",
	"./special-red.svg": "7b3d",
	"./special.svg": "e704"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8208";